import { unhandledRequest } from '../request';

export type Translation = {
  language: string;
  title: string;
};
export type JobLabel = {
  id: number;
  color: string;
  title: string;
  numJobs: number;
};

export async function loadJobLabels() {
  const response = await unhandledRequest.get<JobLabel[]>({
    url: `/joblabel/`,
  });
  return response.data;
}

export type JobLabelCreate = {
  color: string;
  title: string;
};

export async function createJobLabel(data: JobLabelCreate) {
  return await unhandledRequest.post<JobLabel>({
    url: `/joblabel/`,
    data,
  });
}

export type JobLabelEdit = {
  id: number;
  color: string;
  title: string;
};
export async function editJobLabel(data: JobLabelEdit) {
  return await unhandledRequest.patch({
    url: `/joblabel/${data.id}/`,
    data,
  });
}

export async function deleteJobLabel(id: number) {
  return await unhandledRequest.delete({
    url: `/joblabel/${id}/`,
  });
}
